<template>
  <IconLucideTag />
</template>
